import React from 'react'

function Term() {
  return (
    <div>
        <div className="terms-conditions">
      <h1 className='q'>Terms and Conditions</h1>
      <p>Welcome to Our E-commerce Website!</p>
      <p>These terms and conditions outline the rules and regulations for the use of Our Company's Website.</p>
      <h2>1. Introduction</h2>
      <p>By accessing this website, we assume you accept these terms and conditions. Do not continue to use the website if you do not agree to all the terms and conditions stated on this page.</p>
      <h2>2. License</h2>
      <p>Unless otherwise stated, Our Company and/or its licensors own the intellectual property rights for all material on the website. All intellectual property rights are reserved.</p>
      <h2>3. User Comments</h2>
      <p>Certain parts of this website offer the opportunity for users to post and exchange opinions and information. Our Company does not filter, edit, publish, or review Comments prior to their presence on the website.</p>
      <h2>4. Content Liability</h2>
      <p>We shall not be held responsible for any content that appears on your website. You agree to protect and defend us against all claims that are rising on your website.</p>
      <h2>5. Reservation of Rights</h2>
      <p>We reserve the right to request that you remove all links or any particular link to our website. You approve to immediately remove all links to our website upon request.</p>
      <h2>6. Removal of links from our website</h2>
      <p>If you find any link on our website that is offensive for any reason, you are free to contact and inform us any moment. We will consider requests to remove links but we are not obligated to do so or to respond to you directly.</p>
      <h2>7. Disclaimer</h2>
      <p>To the maximum extent permitted by applicable law, we exclude all representations, warranties, and conditions relating to our website and the use of this website.</p>
      <p>...</p>
    </div>
    </div>
  )
}

export default Term
